<template>
  <div
    id="add-to-cart-modal"
    class="modal fade modal-addToCart"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title">{{$t('team.addedSuccessfully')}}</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{$t('addedSelectedSession')}}</p>
          <div class="">
            <a
              href="#"
              class="btn btn-primary btn-icon"
              @click.prevent.stop="closeModal"
            >
              <span class="icon icon-cart_white"></span> {{$t('continuePurchasing')}} </a
            ><br />
            <a href="/cart" class="btn btn-info btn-icon d-flex justify-content-between pr-0">
              {{$t('goToCart')}}  <span class="icon icon-arrow-right_white ml-2"></span> 
            </a>
          </div>
        </div>
        <div
          class="modal-footer d-flex flex-wrap justify-content-between"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddToCartConfirmationModal',
  components: {},
  props: [],
  data() {
    return {}
  },
  mounted() {
    this.$bus.$on('cart.add.confirmation', () => {
      $('#add-to-cart-modal').modal('show')
    })
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        $('#add-to-cart-modal').modal('hide')
      }, 250)
    },
  },
}
</script>
